import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import { useDockedContext } from 'Context/DockedContext';

import DockedItem from './DockedItem';

const styles = theme => ({
  root: {
    position: 'fixed',
    right: 0,
    bottom: 0,
    zIndex: theme.zIndex.drawer,
  },
  item: {},
});

function Dock({
  className,
  classes,
}) {
  const { items } = useDockedContext();

  return (
    <div className={classNames(classes.root, className)}>
      {items.map(item => (
        <DockedItem
          className={classes.item}
          key={item.key}
          item={item}
        />
      ))}
    </div>
  );
}

Dock.defaultProps = {
  className: '',
};

Dock.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Dock);
